import React from "react";

const Awesome = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="77"
      height="77"
      viewBox="0 0 77 77"
      fill="none"
    >
      <path
        d="M38.5 77C59.763 77 77 59.763 77 38.5C77 17.237 59.763 0 38.5 0C17.237 0 0 17.237 0 38.5C0 59.763 17.237 77 38.5 77Z"
        fill="#FBC926"
      />
      <path
        d="M33.9004 72.6984C24.8004 72.6984 16.5004 69.5984 9.90039 64.2984C16.9004 72.0984 27.1004 76.9984 38.4004 76.9984C59.6004 76.9984 76.9004 59.7984 76.9004 38.4984C76.9004 26.2984 71.2004 15.4984 62.4004 8.39844C68.6004 15.1984 72.3004 24.2984 72.3004 34.1984C72.4004 55.3984 55.2004 72.6984 33.9004 72.6984Z"
        fill="#F4BF11"
      />
      <path
        d="M37.8996 56.0016C37.1996 56.0016 36.5996 55.4016 36.5996 54.7016C36.5996 54.0016 37.1996 53.4016 37.8996 53.4016C39.5996 53.4016 40.1996 53.1016 40.2996 53.0016C40.1996 52.6016 39.2996 51.6016 38.7996 51.2016C38.4996 51.1016 38.1996 50.8016 38.0996 50.4016C37.8996 49.9016 38.0996 49.3016 38.4996 49.0016C39.2996 48.4016 40.0996 47.4016 40.1996 47.0016C39.9996 46.9016 39.3996 46.7016 37.8996 46.7016C37.1996 46.7016 36.5996 46.1016 36.5996 45.4016C36.5996 44.7016 37.1996 44.1016 37.8996 44.1016C39.5996 44.1016 41.9996 44.3016 42.6996 46.1016C43.1996 47.5016 42.1996 48.9016 41.2996 49.9016C42.1996 50.8016 42.8996 52.0016 42.8996 53.0016C42.8996 53.6016 42.6996 54.6016 41.3996 55.3016C40.5996 55.9016 39.3996 56.0016 37.8996 56.0016Z"
        fill="#332F2E"
      />
      <path
        d="M17.2004 34.1969C16.5004 34.1969 15.9004 33.5969 15.9004 32.8969C15.9004 29.2969 18.9004 26.2969 22.5004 26.2969C24.9004 26.2969 27.0004 27.5969 28.2004 29.5969C28.6004 30.1969 28.3004 30.9969 27.7004 31.2969C27.1004 31.6969 26.3004 31.3969 26.0004 30.7969C25.3004 29.4969 23.9004 28.7969 22.5004 28.7969C20.3004 28.7969 18.4004 30.5969 18.4004 32.8969C18.4004 33.6969 17.9004 34.1969 17.2004 34.1969Z"
        fill="#332F2E"
      />
      <path
        d="M59.7007 34.1969C59.0007 34.1969 58.4007 33.5969 58.4007 32.8969C58.4007 30.6969 56.6007 28.7969 54.3007 28.7969C52.9007 28.7969 51.5007 29.5969 50.8007 30.7969C50.4007 31.3969 49.7007 31.5969 49.1007 31.2969C48.5007 30.8969 48.3007 30.1969 48.6007 29.5969C49.8007 27.5969 52.0007 26.2969 54.3007 26.2969C57.9007 26.2969 60.9007 29.2969 60.9007 32.8969C61.0007 33.6969 60.4007 34.1969 59.7007 34.1969Z"
        fill="#332F2E"
      />
      <path
        d="M61.0993 44.4981C61.0993 48.7981 51.2993 54.2981 51.2993 54.2981C51.2993 54.2981 45.1993 44.6981 47.2993 40.9981C49.3993 37.2981 53.9993 43.4981 53.9993 43.4981C53.9993 43.4981 61.0993 40.2981 61.0993 44.4981Z"
        fill="#CA68A0"
      />
    </svg>
  );
};

export default Awesome;
